import React, { useState, useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { supabase } from './supabaseClient'
import LandingPage from './components/LandingPage'
import LoginPage from './components/LoginPage'
import Dashboard from './components/Dashboard'
import ModuleDetail from './components/ModuleDetail'
import AdminDashboard from './components/AdminDashboard'
import GMDirectory from './components/GMDirectory'
import ResetPassword from './components/ResetPassword'
import UpdatePassword from './components/UpdatePassword'
import NotFound from './components/NotFound'
import { ADMIN_EMAIL } from './constants'
import './index.css'

function ProtectedRoute({ children, session }) {
  return session ? children : <Navigate to="/login" replace />
}

function AdminRoute({ children, session, userEmail }) {
  if (!session) return <Navigate to="/login" replace />
  if (userEmail !== ADMIN_EMAIL) return <Navigate to="/dashboard" replace />
  return children
}

function AppRoutes({ session, userEmail }) {
  const location = useLocation()
  const onLandingPage = location.pathname === '/'

  return (
    <Routes>
      {/* Landing page - NEVER redirects away regardless of session */}
      <Route path="/" element={<LandingPage />} />

      {/* Login - only redirect if session exists AND we're not coming from signup */}
      <Route path="/login" element={
        (session && !onLandingPage) ? <Navigate to="/dashboard" replace /> : <LoginPage />
      } />

      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/update-password" element={<UpdatePassword />} />

      <Route path="/dashboard" element={<ProtectedRoute session={session}><Dashboard /></ProtectedRoute>} />
      <Route path="/module/:moduleNum" element={<ProtectedRoute session={session}><ModuleDetail /></ProtectedRoute>} />
      <Route path="/cohort" element={<ProtectedRoute session={session}><GMDirectory /></ProtectedRoute>} />
      <Route path="/admin" element={<AdminRoute session={session} userEmail={userEmail}><AdminDashboard /></AdminRoute>} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

export default function App() {
  const [session, setSession] = useState(null)
  const [userEmail, setUserEmail] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session)
      setUserEmail(session?.user?.email || null)
      setLoading(false)
    })

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      // Don't update session if we're on the landing page - prevents signup redirect
      if (window.location.pathname !== '/') {
        setSession(session)
        setUserEmail(session?.user?.email || null)
      }
    })
    return () => subscription.unsubscribe()
  }, [])

  if (loading) return null

  return (
    <BrowserRouter>
      <AppRoutes session={session} userEmail={userEmail} />
    </BrowserRouter>
  )
}
